<template>
	<div class="personalCenter">
		<div class="personalCenter_banner">
			<div><img src="../assets/personImg.png" /></div>
			<div>{{name}}</div>
		</div>
		<div class="personalCenter_container">
			<div class="personalCenter_container_li" @click="personalCenter">
				<div><img src="../assets/admission.png" /></div>
				<div>门票预约</div>
				<div><img src="../assets/person_righr.png" /></div>
			</div>
			<div v-show="test" style="margin-top: 0;border-top: 1px solid #eee;" class="personalCenter_container_li" @click="personalCenter">
				<div><img src="../assets/activity.png" /></div>
				<div>活动预约</div>
				<div><img src="../assets/person_righr.png" /></div>
			</div>
			<div v-show="test" class="personalCenter_container_li" @click="myComplaint">
				<div><img src="../assets/Complaint.png" /></div>
				<div>我的投诉</div>
				<div><img src="../assets/person_righr.png" /></div>
			</div>
			<div v-show="test" style="margin-top: 0;border-top: 1px solid #eee;" class="personalCenter_container_li" @click="myLease">
				<div><img src="../assets/center_lease.png" /></div>
				<div>我的租赁</div>
				<div><img src="../assets/person_righr.png" /></div>
			</div>
			<div v-show="test" class="personalCenter_container_li" @click="mySeekPeople">
				<div><img src="../assets/center_seekpeople.png" /></div>
				<div>我的寻人</div>
				<div><img src="../assets/person_righr.png" /></div>
			</div>
			<div v-show="test" style="margin-top: 0;border-top: 1px solid #eee;" class="personalCenter_container_li" @click="mySeekwu">
				<div><img src="../assets/center_seekwu.png" /></div>
				<div>我的失物</div>
				<div><img src="../assets/person_righr.png" /></div>
			</div>
			<div class="personalCenter_container_li" style="margin-bottom: 70px;" @click="ChangePassword">
				<div><img src="../assets/pass.png" /></div>
				<div>修改密码</div>
				<div><img src="../assets/person_righr.png" /></div>
			</div>
		</div>
		<div class="release_btn">
			<div class="release_btn_cli" @click="sign_out">退出登录</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'PersonalCenter',
		data() {
			return {
				name:"",
				baseUrl:"",
				test:false
			}
		},
		methods: {
			myLease(){
				var that=this;
				that.$router.push({
					name: 'MyLease'
				});
			},
			myComplaint(){
				var that=this;
				that.$router.push({
					name: 'MyComplaint'
				});
			},
			mySeekPeople(){
				var that=this;
				that.$router.push({
					name: 'SearchForPeople'
				});
			},
			mySeekwu(){
				var that=this;
				that.$router.push({
					name: 'LostArticle'
				});
			},
			ChangePassword() {
				var that = this;
				that.$router.push({
					name: 'ChangePassword'
				});
			},
			personalCenter(){
				var that = this;
				sessionStorage.removeItem('holder')
				sessionStorage.removeItem('tcid')
				that.$router.push({
					name: 'TicketReservation'
				});
			},
			sign_out() {
				var that = this;
				wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
				wclient.ajax({
					type: "GET",
					url: that.baseUrl + '/tickets/tickets/ajax?ugi=loginUgi&action=logoutLogin',
					dataType: "json",
					async: true,
					data: {

					},
					success: function(data) {
						if(data.code == 'A00006') {
							sessionStorage.removeItem("name");
							sessionStorage.removeItem("teamtype");
							sessionStorage.removeItem("loginType");
							that.$router.push({
								name: "CenterLand"
							})
						}
					}
				});
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.test=true;
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.test=true;
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.test=false;
			}
			that.baseUrl = baseUrl;
			that.name=sessionStorage.getItem("name");
		}
	}
</script>

<style scoped>
	.personalCenter {
		width: 100%;
		height: 100vh;
		background: #EEEEEE;
	}
	
	.personalCenter_banner {
		width: 100%;
		height: 20%;
		background: url(../assets/personbg.png) center center no-repeat;
		background-size: cover;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-weight: 600;
		color: rgba(255, 255, 255, 1);
		font-size: 17px;
		letter-spacing: 1px;
		float: left;
	}
	
	.personalCenter_banner div {
		margin-left: 5%;
	}
	
	.personalCenter_banner div:nth-child(1) {
		width: 70px;
		height: 70px;
		border-radius: 50%;
		overflow: hidden;
		margin-left: 8%;
	}
	
	.personalCenter_banner img {
		width: 100%;
	}
	
	.personalCenter_container {
		float: left;
		width: 100%;
	}
	
	.personalCenter_container_li {
		width: 90%;
		float: left;
		margin-top: 8px;
		background: white;
		padding: 0 5%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.personalCenter_container_li div:nth-child(1) {
		width: 6%;
		margin-right: 5%;
	}
	
	.personalCenter_container_li div:nth-child(2) {
		width: 89%;
		line-height: 50px;
		font-weight: 400;
		color: rgba(33, 33, 33, 1);
		font-size: 16px;
	}
	
	.personalCenter_container_li div:nth-child(3) {
		width: 2%;
	}
	
	.sign_out {
		width: 70%;
		position: fixed;
		bottom: 5%;
		left: 15%;
		line-height: 45px;
		text-align: center;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));;
		border-radius: 62px;
		color: rgba(254, 254, 254, 1);
		font-size: 14px;
	}
	.release_btn {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background: white;
		padding: 15px 0;
		border-top: 1px solid #DBDBDB;
	}
	
	.release_btn_cli {
		width: 70%;
		margin: 0 auto;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		line-height: 40px;
		text-align: center;
		color: white;
		border-radius: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/components/teamCenter.vue